//@ts-nocheck
import { parseISO, isBefore, startOfToday, format, eachDayOfInterval } from "date-fns";
import dayjs from "dayjs";
import { DaypartDTO, FlattenedRow } from "../types/adminInterface";




/**
 * Returns true if the currently logged-in user has the Admin role.
 * Checks both roleId === 1 (legacy) AND the role name stored in userInfo,
 * so it works regardless of the backend ID assigned to the Admin role.
 */


export const isAdminUser = (): boolean => {
  const roleId = Number(localStorage.getItem('roleId'));
  if (roleId === 1) return true;
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const currentRole = userInfo?.userroles?.find((r: any) => r.userroleid === roleId);
    return currentRole?.userrolename?.toLowerCase() === 'admin';
  } catch {
    return false;
  }
};
// get unique objects based on key matching
export const arrayObjectUniqSetKey = (
  arrayObj: object[],
  keyName: string
) => {
  return Array.from(new Set(arrayObj.map((obj: any) => obj[keyName])))?.map(
    (keyValue: any) => arrayObj.find((obj: any) => obj[keyName] === keyValue)
  );
};

// check if past date using date-fns
const DEFAULT_DATE_STRING = "0001-01-01T00:00:00";
export const isPastDate = (dateString: string, today?: string = ""): boolean => {
  const inputDate = parseISO(dateString);
  const todayDatetime = !!today ? today : startOfToday();
  return isBefore(inputDate, todayDatetime) && dateString !== DEFAULT_DATE_STRING;
};

export const compareDateIsBefore = (dateToCompare: string): boolean => {
  const currentDate = dayjs(); // Current date and time
  const pastDate = dayjs(dateToCompare); // Convert the passed date
  return pastDate.isBefore(currentDate);
};

export const compareArraysValues = (a: any[], b: any[]) => {
  if (a?.length !== b?.length) return false;
  else {
    // Comparing each element of your array one by one
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }
};

// get fromatted date
export const getFormattedDate = (datestring, dateFormat) => {
  const parsedDate = parseISO(datestring);
  const formattedDate = format(parsedDate, dateFormat)
  return formattedDate;
};

// get fromatted date range
export const getFormattedDateRange = (fromDate: any, toDate: any, dateFormat) => {
  // Parse the ISO strings into Date objects
  const startDate = parseISO(fromDate);
  const endDate = parseISO(toDate);
  // Get all the dates in the range
  const dates = eachDayOfInterval({ start: startDate, end: endDate });
  // Format the dates into the desired format
  const formattedDates = dates.map(date => format(date, dateFormat));
  return formattedDates;
}

// Destructuring data for IMP export & report
export const transformData = (data) => { 
  return data.map(daypart => {
    const transformedDaypart = {
      daypart: daypart?.name || daypart?.daypartname || '',
      regular: {
        name: "",
        data: []
      },
      foodProgram: {
        name: "",
        data: []
      },
      combo: {
        name: "",
        data: []
      },
      event: {
        name: "",
        data: []
      },
      bakery: {
        name: "",
        data: []
      }
    };

    const allDates = daypart.plandatereportlist.map(plandateReport => plandateReport.plandate);

    daypart.plandatereportlist.forEach(plandateReport => {
      const date = plandateReport.plandate;

      plandateReport.menuplantypelist.forEach(menuType => {
        if (menuType.menuplantypename === "Regular" || menuType.menuplantypename === "Event" || menuType.menuplantypename === "Bakery") {
          // Process Regular / event / bakery
          let isdatapresent = false;
          const menutypename = menuType?.menuplantypename?.toLowerCase();
          transformedDaypart[menutypename].name = menuType.menuplantypename
          menuType.dishcategories.forEach((category, idx) => {
            let existingCategory = transformedDaypart[menutypename]?.data.find(c => c.dishCategory === category.dishcategoryname);
            if (!existingCategory) {
              existingCategory = { dishCategory: category.dishcategoryname, dates: [] };
              transformedDaypart[menutypename]?.data.push(existingCategory);
            }

            if (!!category.dishes.length) isdatapresent = true;

            // check if date exist, the push dishes in same date's dishes
            const existingDate = existingCategory.dates.find(item => item.date === date);
            if (existingDate) {
              // Clone the existing dishes array and append the new dishes
              existingDate.dishes = [
                ...(existingDate.dishes || []),
                ...(category.dishes || [])
              ];
            } else {
              existingCategory.dates.push({
                date,
                dishes: category.dishes || []
              });
            }

            // on last iteration check if any of the category has dishes 
            if (menuType.dishcategories.length === idx + 1 && !isdatapresent) {
              transformedDaypart[menutypename]?.data.pop(existingCategory);
            }

          });
        } else if (menuType.menuplantypename === "Food Program") {
          // Process Food Program
          transformedDaypart.foodProgram.name = menuType?.menuplantypename
          menuType.foodprogramlist.forEach(program => {
            let existingProgram = transformedDaypart.foodProgram?.data.find(p => p.foodProgramName === program.foodprogramname);
            if (!existingProgram) {
              existingProgram = { foodProgramName: program.foodprogramname, categories: [] };
              transformedDaypart.foodProgram?.data.push(existingProgram);
            }
            program.dishcategories.forEach(category => {
              let existingCategory = existingProgram.categories.find(c => c.category === category.dishcategoryname || c.category === null);
              if (!existingCategory) {
                existingCategory = { category: category.dishcategoryname || null, dates: [] };
                existingProgram.categories.push(existingCategory);
              }
              existingCategory.dates.push({
                date,
                items: category.dishes.length > 0 ? category.dishes : program.items || []
              });
            });
          });
        } else if (menuType.menuplantypename === "Combo") {
          // Process Combo
          transformedDaypart.combo.name = "Combo"
          menuType.combolist.forEach((combo, index) => {
            let existingCombo = transformedDaypart.combo?.data.find(c => c.id === combo.menuplancomboid);
            if (!existingCombo) {
              existingCombo = { 
                id: combo.menuplancomboid, 
                dates: [], 
                combonumber: index + 1,
                comboname: combo.comboname,
                customcomboname: combo.customcomboname
              };
              transformedDaypart.combo?.data.push(existingCombo);
            }
            existingCombo.dates.push({
              date,
              dishes: combo.dishes || []
            });
          });
        }
      });
    });

    // Sort dates in ascending order for each category
    transformedDaypart.regular?.data.length ? transformedDaypart.regular?.data.forEach(category => {
      const existingDates = category.dates.map(d => d.date);
      allDates.forEach(date => {
        if (!existingDates.includes(date)) {
          category.dates.push({ date, dishes: [] });
        }
      });
      category.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
    }) : delete transformedDaypart.regular;

    transformedDaypart.event?.data.length ? transformedDaypart.event?.data.forEach(category => {
      const existingDates = category.dates.map(d => d.date);
      allDates.forEach(date => {
        if (!existingDates.includes(date)) {
          category.dates.push({ date, dishes: [] });
        }
      });
      category.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
    }) : delete transformedDaypart.event;

    transformedDaypart.bakery?.data.length ? transformedDaypart.bakery?.data.forEach(category => {
      const existingDates = category.dates.map(d => d.date);
      allDates.forEach(date => {
        if (!existingDates.includes(date)) {
          category.dates.push({ date, dishes: [] });
        }
      });
      category.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
    }) : delete transformedDaypart.bakery;

    transformedDaypart.foodProgram?.data.length ? transformedDaypart.foodProgram?.data.forEach(program => {
      program.categories.forEach(category => {
        const existingDates = category.dates.map(d => d.date);
        allDates.forEach(date => {
          if (!existingDates.includes(date)) {
            category.dates.push({ date, items: [] });
          }
        });
        category.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
      });
    }) : delete transformedDaypart.foodProgram;

    transformedDaypart.combo?.data.length ? transformedDaypart.combo?.data.forEach(combo => {
      const existingDates = combo.dates.map(d => d.date);
      allDates.forEach(date => {
        if (!existingDates.includes(date)) {
          combo.dates.push({ date, dishes: [] });
        }
      });
      combo.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
    }) : delete transformedDaypart.combo;

   // console.log(transformedDaypart)
    return transformedDaypart;

  });

}

export const ItemtransformData = (data) => {
  // console.log("Transforming projection data fs001", data);
  return data.map(daypart => {
    const transformedDaypart = {
      daypart: daypart?.name || daypart?.daypartname || '',
      regular: {
        name: "",
        data: []
      },
     
      event: {
        name: "",
        data: []
      },
    
    };

    const allDates = daypart.plandatereportlist.map(plandateReport => plandateReport.plandate);

    daypart.plandatereportlist.forEach(plandateReport => {
      const date = plandateReport.plandate;

      plandateReport.menuplantypelist.forEach(menuType => {
        if (menuType.menuplantypename === "Regular" || menuType.menuplantypename === "Event") {
          // Process Regular / event / bakery
          let isdatapresent = false;
          const menutypename = menuType?.menuplantypename?.toLowerCase();
          transformedDaypart[menutypename].name = menuType.menuplantypename
          
          // Support both shapes: menuType.dishcategories (legacy) and menuType.items[].dishcategories (new)
          const categoriesList = Array.isArray(menuType.dishcategories) && menuType.dishcategories.length > 0
            ? menuType.dishcategories
            : (Array.isArray(menuType.items) 
                ? menuType.items.flatMap(item => (item.dishcategories || []).map(cat => ({...cat, itemname: item.itemname, itemcode: item.itemcode})))
                : []);
          
          categoriesList.forEach((category, idx) => {
            let existingCategory = transformedDaypart[menutypename]?.data.find(c => c.dishCategory === category.dishcategoryname);
            if (!existingCategory) {
              existingCategory = { dishCategory: category.dishcategoryname, dates: [] };
              transformedDaypart[menutypename]?.data.push(existingCategory);
            }

            if (!!category.dishes.length) isdatapresent = true;

            // Map dishes and attach item metadata if present
            const dishesWithMetadata = (category.dishes || []).map(dish => ({
              ...dish,
              itemname: category.itemname || dish.itemname || '',
              itemcode: category.itemcode || dish.itemcode || ''
            }));

            // check if date exist, the push dishes in same date's dishes
            const existingDate = existingCategory.dates.find(item => item.date === date);
            if (existingDate) {
              // Clone the existing dishes array and append the new dishes
              existingDate.dishes = [
                ...(existingDate.dishes || []),
                ...dishesWithMetadata
              ];
            } else {
              existingCategory.dates.push({
                date,
                dishes: dishesWithMetadata
              });
            }

            // on last iteration check if any of the category has dishes 
            if (categoriesList.length === idx + 1 && !isdatapresent) {
              transformedDaypart[menutypename]?.data.pop(existingCategory);
            }

          });
        }       
        
      });
    });

    // Sort dates in ascending order for each category
    transformedDaypart.regular?.data.length ? transformedDaypart.regular?.data.forEach(category => {
      const existingDates = category.dates.map(d => d.date);
      allDates.forEach(date => {
        if (!existingDates.includes(date)) {
          category.dates.push({ date, dishes: [] });
        }
      });
      category.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
    }) : delete transformedDaypart.regular;

    transformedDaypart.event?.data.length ? transformedDaypart.event?.data.forEach(category => {
      const existingDates = category.dates.map(d => d.date);
      allDates.forEach(date => {
        if (!existingDates.includes(date)) {
          category.dates.push({ date, dishes: [] });
        }
      });
      category.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
    }) : delete transformedDaypart.event;

    transformedDaypart.bakery?.data.length ? transformedDaypart.bakery?.data.forEach(category => {
      const existingDates = category.dates.map(d => d.date);
      allDates.forEach(date => {
        if (!existingDates.includes(date)) {
          category.dates.push({ date, dishes: [] });
        }
      });
      category.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
    }) : delete transformedDaypart.bakery;

    transformedDaypart.foodProgram?.data.length ? transformedDaypart.foodProgram?.data.forEach(program => {
      program.categories.forEach(category => {
        const existingDates = category.dates.map(d => d.date);
        allDates.forEach(date => {
          if (!existingDates.includes(date)) {
            category.dates.push({ date, items: [] });
          }
        });
        category.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
      });
    }) : delete transformedDaypart.foodProgram;

    transformedDaypart.combo?.data.length ? transformedDaypart.combo?.data.forEach(combo => {
      const existingDates = combo.dates.map(d => d.date);
      allDates.forEach(date => {
        if (!existingDates.includes(date)) {
          combo.dates.push({ date, dishes: [] });
        }
      });
      combo.dates.sort((a, b) => new Date(a.date) - new Date(b.date));
    }) : delete transformedDaypart.combo;

    // console.log(transformedDaypart)
    return transformedDaypart;

  });

}

// Transform data to be organized by items instead of dayparts
export const transformDataItemWise = (data) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    // console.log('transformDataItemWise: Invalid or empty data', data);
    return [];
  }
  
  // console.log('transformDataItemWise: Processing data', data);
  
  const itemsMap = new Map();
  const allDates = [];
  
  // Collect all unique dates first
  data.forEach(daypart => {
    daypart.plandatereportlist.forEach(plandateReport => {
      if (!allDates.includes(plandateReport.plandate)) {
        allDates.push(plandateReport.plandate);
      }
    });
  });
  
  // Sort dates
  allDates.sort((a, b) => new Date(a) - new Date(b));
  
  // Process each daypart
  data.forEach(daypart => {
    const daypartName = daypart.name;
    
    daypart.plandatereportlist.forEach(plandateReport => {
      const planDate = plandateReport.plandate;
      
      plandateReport.menuplantypelist.forEach(menuType => {
        const menuTypeName = menuType.menuplantypename;
        
        // Process items
        if (menuType.items && menuType.items.length > 0) {
          menuType.items.forEach(item => {
            const itemKey = `${item.itemcode}-${item.itemname}`;
            
            if (!itemsMap.has(itemKey)) {
              itemsMap.set(itemKey, {
                itemCode: item.itemcode,
                itemName: item.itemname,
                isAllSite: item.isallsite,
                dayparts: {}
              });
            }
            
            const itemData = itemsMap.get(itemKey);
            
            // Initialize daypart if not exists
            if (!itemData.dayparts[daypartName]) {
              itemData.dayparts[daypartName] = {
                daypartName: daypartName,
                menuTypes: {}
              };
            }
            
            // Initialize menu type if not exists
            if (!itemData.dayparts[daypartName].menuTypes[menuTypeName]) {
              itemData.dayparts[daypartName].menuTypes[menuTypeName] = {
                menuTypeName: menuTypeName,
                dishCategories: {}
              };
            }
            
            // Process dish categories
            if (item.dishcategories && item.dishcategories.length > 0) {
              item.dishcategories.forEach(dishCategory => {
                const categoryKey = dishCategory.dishcategoryname || 'No Category';
                
                if (!itemData.dayparts[daypartName].menuTypes[menuTypeName].dishCategories[categoryKey]) {
                  itemData.dayparts[daypartName].menuTypes[menuTypeName].dishCategories[categoryKey] = {
                    categoryName: categoryKey,
                    categoryCode: dishCategory.dishcategorycode,
                    dates: {}
                  };
                }
                
                const categoryData = itemData.dayparts[daypartName].menuTypes[menuTypeName].dishCategories[categoryKey];
                
                // Initialize date if not exists
                if (!categoryData.dates[planDate]) {
                  categoryData.dates[planDate] = {
                    date: planDate,
                    dishes: []
                  };
                }
                
                // Add dishes for this date
                if (dishCategory.dishes && dishCategory.dishes.length > 0) {
                  categoryData.dates[planDate].dishes.push(...dishCategory.dishes);
                }
              });
            }
          });
        }
      });
    });
  });
  
  // Convert map to array and fill missing dates
  const result = Array.from(itemsMap.values()).map(item => {
    // Fill missing dates for each category
    Object.values(item.dayparts).forEach(daypart => {
      Object.values(daypart.menuTypes).forEach(menuType => {
        Object.values(menuType.dishCategories).forEach(category => {
          allDates.forEach(date => {
            if (!category.dates[date]) {
              category.dates[date] = {
                date: date,
                dishes: []
              };
            }
          });
          
          // Convert dates object to sorted array
          category.datesList = allDates.map(date => category.dates[date]);
        });
      });
    });
    
    return item;
  });
  
  // console.log('transformDataItemWise: Final result', result);
  return result;
};


// ---------------------------------
// 1) Field Ranges
// ---------------------------------
const FIELD_RANGES: Record<string, [number, number]> = {
  // For array-based fields
  weeksbeforeprojection: [0, 12],
  dayofweek: [0, 7],
  dateofmonth: [0, 31],
  cutofftimehh: [0, 23],
  cutofftimemm: [0, 59],
  alertnotificationminutes: [0, 59],
  cuttoffday: [0, 100],


  // For single-value fields
  reviewtimeperiodmonths: [0, 12],
  reviewtimeperiodmonths: [0, 12],
  pastmonthprojection: [0, 12],
  pastmonthrequisition: [0, 12],
  pastmonthexceptionalrequisition: [0, 12],
  pastmonthprojectiondashboard: [0, 12],
  pastmonthkitchendashboard: [0, 12],
  pastmonthsitemanagerdashboard: [0, 12],
  reviewtimeperiodmonths: [0, 12],

  projectionquantitytolerancepercentage: [0, 100],
  requisitionquantitytolerancepercentage: [0, 100],
  exceptionalrequisitionquantitytolerancepercentage: [0, 100],

};

export function clampValueNoForce(
  fieldName: string,
  rawValue: string | number
): number | '' | undefined {
  // 1) If user cleared the input
  if (rawValue === '') {
    return '';
  }

  // 2) Convert to integer
  let val =
    typeof rawValue === 'number'
      ? rawValue
      : parseInt(rawValue, 10);

  if (Number.isNaN(val)) {
    // If parse fails, treat as empty
    return '';
  }

  // Optional: force integer
  val = Math.floor(val);

  // 3) Check if we have a [min, max] for this field
  const range = FIELD_RANGES[fieldName];
  if (range) {
    const [minVal, maxVal] = range;
    // If below min or above max, return undefined => skip updating
    if (val < minVal || val > maxVal) {
      return undefined;
    }
  }

  return val;
}

export function validateAndUpdateField(
  index: number,
  fieldName: string,
  rawValue: string | number,
  setArrayState: React.Dispatch<React.SetStateAction<any[]>>,
  setIsPublishButtonDisabled?: React.Dispatch<React.SetStateAction<boolean>>
) {
  // If provided, re-enable "Publish" button
  if (setIsPublishButtonDisabled) {
    setIsPublishButtonDisabled(false);
  }

  // 1) Try to get a valid new value
  const newValue = clampValueNoForce(fieldName, rawValue);

  // 2) If `undefined`, the user typed an out-of-range integer => skip
  if (newValue === undefined) {
    return;
  }

  // 3) Otherwise, update the item
  setArrayState((prev) =>
    prev.map((item, i) =>
      i === index
        ? { ...item, [fieldName]: newValue }
        : item
    )
  );
}




const normalizeObject = (obj: Record<string, any>): Record<string, any> => {
  const normalized: Record<string, any> = { ...obj };
  Object.keys(normalized).forEach((key) => {
    if (
      normalized[key] === null ||
      normalized[key] === undefined ||
      normalized[key] === ''
    ) {
      normalized[key] = 0;
    }
  });
  return normalized;
};

// Normalize an array of objects by applying normalizeObject to each item.
export const normalizeArray = (arr: any[]): any[] => {
  return arr.map((item) => normalizeObject(item));
};

// Normalize form values (a flat object of key/value pairs).
export const normalizeValues = (vals: FormValues): FormValues => {
  const normalized: Partial<FormValues> = {};
  Object.keys(vals).forEach((key) => {
    // Using loose equality to catch both null and empty string.
    normalized[key] = vals[key] == null || vals[key] === '' ? 0 : vals[key];
  });
  return normalized as FormValues;
};


export function formatDateTime12h(dateStr?: string | null): string {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}
export function formatPlanDate(dateInput?: Date | string | null): string {
  if (!dateInput) return "";
  const d = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    weekday: "short",
  });
}


export function flattenDaypart(
  dp: DaypartDTO,
  fromDate: Date,
  toDate: Date
): { originalRows: FlattenedRow[]; dateHeadings: string[] } {
  const flattenedRows: FlattenedRow[] = [];

  // For each site -> each cafe -> build row objects
  dp.sites.forEach((site) => {
    site.cafelist.forEach((cafe) => {
      // Sort menustatus by plandate
      const menustatus = (cafe.menustatus || [])
        .slice()
        .sort(
          (a, b) =>
            new Date(a.plandate).getTime() - new Date(b.plandate).getTime()
        )
        .map((ms) => ({
          ...ms,
          formattedplandate: formatPlanDate(ms.plandate),
        }));

      // Convert initiated/lastModified to date-only (filter) + date-time (display)
      let initDateOnly = "";
      let lastDateOnly = "";
      let initDisplay = "";
      let lastDisplay = "";

      if (cafe.intiatedon) {
        const initObj = new Date(cafe.intiatedon);
        if (!isNaN(initObj.getTime())) {
          initDateOnly = format(initObj, "dd MMM yyyy");
          initDisplay = formatDateTime12h(cafe.intiatedon);
        }
      }
      if (cafe.lastmodifiedon) {
        const lastObj = new Date(cafe.lastmodifiedon);
        if (!isNaN(lastObj.getTime())) {
          lastDateOnly = format(lastObj, "dd MMM yyyy");
          lastDisplay = formatDateTime12h(cafe.lastmodifiedon);
        }
      }

      flattenedRows.push({
        sitename: `${site.sitename} (${site.sitecode || "?"})`,
        sitecode: site.sitecode,
        cafename: cafe.name || "",
        cafecode: cafe.cafecode || "",
        initiatedby: cafe.intiatedby || "",

        initiatedon: initDateOnly,
        lastmodifiedon: lastDateOnly,

        initiatedonDisplay: initDisplay,
        lastmodifiedonDisplay: lastDisplay,

        menustatus,
        statuses: [],
      });
    });
  });

  // Build date headings from fromDate..toDate
  let dateHeadings: string[] = [];
  if (!isNaN(fromDate.getTime()) && !isNaN(toDate.getTime()) && fromDate <= toDate) {
    const range = eachDayOfInterval({ start: fromDate, end: toDate });
    dateHeadings = range.map((d) => formatPlanDate(d));
  }

  // Fill row.statuses for each row
  flattenedRows.forEach((row) => {
    row.statuses = dateHeadings.map((pd) => {
      const found = row.menustatus.find(
        (ms) => (ms.formattedplandate || "").toLowerCase() === pd.toLowerCase()
      );
      return found ? String(found.status) : "";
    });
  });
  return { originalRows: flattenedRows, dateHeadings };
}



/**
 * Applies thin borders to all non-styled data rows and a solid white fill to
 * every cell in the extended sheet range (to suppress Excel gridlines).
 *
 * @param worksheet  - The xlsx-js-style worksheet object (mutated in-place)
 * @param rowIndexes - Array of { index, style } produced by the data-build loop
 * @param totalRows  - Number of data rows (e.g. sheetData.length)
 * @param dataCols   - Number of data columns to apply borders to (e.g. 7 for A–G)
 * @param extRowMin  - Minimum number of rows to extend the sheet ref to (default 300)
 * @param extColMin  - Minimum number of cols to extend the sheet ref to (default 50)
 */
export function applyXlsxSheetStyles(
  worksheet: any,
  rowIndexes: { index: number; style: string }[],
  totalRows: number,
  dataCols: number,
  extRowMin = 300,
  extColMin = 50
): void {
  // --- 1. Thin borders on data (non-styled) rows ---
  const styledRowSet = new Set(rowIndexes.map((r) => r.index));
  const thinBorder = {
    top:    { style: 'thin', color: { rgb: '000000' } },
    bottom: { style: 'thin', color: { rgb: '000000' } },
    left:   { style: 'thin', color: { rgb: '000000' } },
    right:  { style: 'thin', color: { rgb: '000000' } },
  };
  for (let rowIdx = 0; rowIdx < totalRows; rowIdx++) {
    if (styledRowSet.has(rowIdx)) continue;
    // Detect blank/spacer rows — rows where every data cell is empty
    let hasData = false;
    for (let ci = 0; ci < dataCols; ci++) {
      const testCell = encodeXlsxCell(rowIdx, ci);
      if (worksheet[testCell] && worksheet[testCell].v !== '' && worksheet[testCell].v != null) {
        hasData = true;
        break;
      }
    }
    if (!hasData) {
      // Actively remove any borders previously set (e.g. by manual loops in the export handler)
      for (let colIdx = 0; colIdx < dataCols; colIdx++) {
        const ca = encodeXlsxCell(rowIdx, colIdx);
        if (worksheet[ca] && worksheet[ca].s) {
          delete worksheet[ca].s.border;
        }
      }
      continue;
    }
    for (let colIdx = 0; colIdx < dataCols; colIdx++) {
      const ca = encodeXlsxCell(rowIdx, colIdx);
      if (!worksheet[ca]) worksheet[ca] = { v: '', t: 's', s: {} };
      if (!worksheet[ca].s) worksheet[ca].s = {};
      worksheet[ca].s.border = thinBorder;
    }
  }
  // --- 2. Extend sheet ref + white fill to suppress gridlines ---
  const extRows = Math.max(totalRows, extRowMin);
  const extCols = Math.max(dataCols, extColMin);
  worksheet['!ref'] = encodeXlsxRange(0, 0, extRows - 1, extCols - 1);
  for (let rowIdx = 0; rowIdx < extRows; rowIdx++) {
    for (let colIdx = 0; colIdx < extCols; colIdx++) {
      const ca = encodeXlsxCell(rowIdx, colIdx);
      if (!worksheet[ca]) worksheet[ca] = { v: '', t: 's', s: {} };
      if (!worksheet[ca].s) worksheet[ca].s = {};
      if (!worksheet[ca].s.fill) {
        worksheet[ca].s.fill = { patternType: 'solid', fgColor: { rgb: 'FFFFFF' } };
      }
    }
  }
}

/** Encodes a zero-based {row, col} pair to an A1-style cell address (e.g. "A1") */
function encodeXlsxCell(row: number, col: number): string {
  const colStr = colToLetter(col);
  return `${colStr}${row + 1}`;
}

/** Encodes a zero-based range to an A1:ZZ999-style ref string */
function encodeXlsxRange(sr: number, sc: number, er: number, ec: number): string {
  return `${encodeXlsxCell(sr, sc)}:${encodeXlsxCell(er, ec)}`;
}

function colToLetter(col: number): string {
  let letter = '';
  let n = col;
  while (n >= 0) {
    letter = String.fromCharCode((n % 26) + 65) + letter;
    n = Math.floor(n / 26) - 1;
  }
  return letter;
}

